import React, { FC, useState, useEffect } from "react";
import { IonIcon, IonItem, IonLabel, IonMenuToggle, IonBadge } from "@ionic/react";
import cn from "classnames";
import {
  viewDashboard,
  viewSettings,
  viewBills,
  viewPayments,
  viewProviders,
  viewOffers,
  viewFuel
} from "../../constants/global";
import { MenuProps, Page } from "./Menu.model";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { userState, viewState, offerState } from "../../atoms";
import { signupInProgress } from "../../utils/signupInProgress";
import HomeIcon from "../../assets/Menu/home.svg";
import HomeActiveIcon from "../../assets/Menu/home-active.svg";
import BillsIcon from "../../assets/Menu/bills.svg";
import BillsActiveIcon from "../../assets/Menu/bills-active.svg";
import PaymentIcon from "../../assets/Menu/payment.svg";
import PaymentActiveIcon from "../../assets/Menu/payment-active.svg";
import ProvidersIcon from "../../assets/Menu/providers.svg";
import OffersIcon from "../../assets/Menu/offers.svg";
import FuelIcon from "../../assets/Menu/fuel.svg";
import SettingsIcon from "../../assets/Menu/settings.svg";
import SettingsActiveIcon from "../../assets/Menu/settings-active.svg";

const pages: Page[] = [
  { title: 'dashboard', path: viewDashboard, icon: HomeIcon, activeIcon: HomeActiveIcon },
  { title: 'bills', path: viewBills, icon: BillsIcon, activeIcon: BillsActiveIcon },
  { title: 'payments', path: viewPayments, icon: PaymentIcon, activeIcon: PaymentActiveIcon },
  { title: 'providers', path: viewProviders, icon: ProvidersIcon, activeIcon: ProvidersIcon },
  { title: 'offers', path: viewOffers, icon: OffersIcon, activeIcon: OffersIcon },
  //{ title: 'fuel card', path: viewFuel, icon: FuelIcon, activeIcon: FuelIcon },
  { title: 'settings', path: viewSettings, icon: SettingsIcon, activeIcon: SettingsActiveIcon },
];

const Menu: FC<MenuProps> = ({ onOpen }) => {
  const [activePage, setActivePage] = useState<string>(pages[0].title);

  const user = useRecoilValue(userState);
  const offers = useRecoilValue(offerState);
  const setView = useSetRecoilState(viewState)
  const view = useRecoilValue(viewState);
  const navigateToPage = (page: Page) => {
    setView(page.path)
    setActivePage(page.title);
    onOpen()
  }

  useEffect(() => {
    setActivePage(view.description)
  }, [view])

  return (
    <>
      {
        pages?.filter((page: Page) => !['payments', 'fuel card'].includes(page?.title) || user?.paymentOption === 'SMOOV' )
          .map((page: Page) => {
          const activeItem = page.title === activePage
          return (
            <IonMenuToggle key={page.title} auto-hide="false">
              <IonItem
                button
                onClick={() => navigateToPage(page)}
                className="menu-item-layout"
                disabled={page.title !== 'dashboard' && signupInProgress(user)}
              >
                <IonIcon src={activeItem ? page.activeIcon : page.icon} className="icon-layout" />
                <IonLabel className={cn('label-layout', { 'active': activeItem })}>
                  {page.title} {page.title === 'offers' && offers?.some(offer => offer.status === 'NEW') && <IonBadge color="warning">{offers?.length}</IonBadge> }
                </IonLabel>
              </IonItem>
            </IonMenuToggle>
          )
        })
      }
    </>
  )
}

export default Menu
